export const PDF_EXPORT_DOWNLOAD_LINK_PATH = '/forms/file/download-link';
// AD-2585: a refused documents download is explained in the report box, so the member of staff stays on the page
export const PROFILE_DOCUMENTS_ZIP_PATH = '/profile-documents/zip';

const STAY_ON_PAGE_PATHS = [PDF_EXPORT_DOWNLOAD_LINK_PATH, PROFILE_DOCUMENTS_ZIP_PATH];

export const shouldRedirectHomeOnForbidden = (requestUrl) =>
    !STAY_ON_PAGE_PATHS.some(path => requestUrl?.includes(path));
